<div style="display: flex">
  <div class="table-container">
    <h3>Currency</h3>
    <mat-form-field appearance="outline" *ngIf="kfRegistrationDetail?.kfRegistration">
      <mat-label>Currency</mat-label>
      <mat-select [value]="kfRegistrationDetail.kfRegistration.currency" disabled>
        <mat-option *ngFor="let currency of currencies" [value]="currency.name">{{currency.name}} ({{currency.symbol}})</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline"
                    *ngIf="!kfRegistrationDetail.kfRegistration.currency || kfRegistrationDetail.kfRegistration.currency !== 'Euro'">
      <mat-label>1 {{kfRegistrationDetail.kfRegistration?.currency}} equals to ? euro(s)</mat-label>
      <input matInput [value]="kfRegistrationDetail.kfRegistration?.equivalence?.toString()" disabled>
    </mat-form-field>
  </div>
  <mat-form-field appearance="outline"
                  *ngIf="!kfRegistrationDetail.kfRegistration.currency || kfRegistrationDetail.kfRegistration.currency !== 'Euro'">
    <mat-label>Exchange source justification</mat-label>
    <textarea matInput [value]="kfRegistrationDetail.kfRegistration.source" disabled></textarea>
  </mat-form-field>
</div>
<div class="table-container">
  <h3>Operations</h3>
  <table *ngIf="kfRegistrationDetail" class="kf-registration-table-cost-operations" mat-table
         [dataSource]="kfRegistrationDetail.categories">
    <ng-container matColumnDef="entry">
      <th mat-header-cell *matHeaderCellDef>Entry</th>
      <td mat-cell *matCellDef="let category; let i = index">
        {{categories[i].description}}
        <span>{{category.kind}}</span>
      </td>
      <td mat-footer-cell *matFooterCellDef> Total Operations</td>
    </ng-container>
    <ng-container matColumnDef="collection">
      <th mat-header-cell *matHeaderCellDef>Collection</th>
      <td mat-cell *matCellDef="let item"
          [matTooltip]="item.collectionDifferentValueAllowed ? 'This value exceeded the marginal value established' : ''">
        <span [className]="item.collectionDifferentValueAllowed ? 'value-exceeded' : ''">{{item.collection  | number: '1.2-2'}} </span>
        <span class="value-exceeded" *ngIf="item.collectionDifferentValueAllowed">*</span>
      </td>
      <td mat-footer-cell *matFooterCellDef> {{totalCollection | number: '1.2-2'}} </td>
    </ng-container>
    <ng-container matColumnDef="logistics">
      <th mat-header-cell *matHeaderCellDef>Logistics</th>
      <td mat-cell *matCellDef="let item"
          [matTooltip]="item.logisticsDifferentValueAllowed ? 'This value exceeded the marginal value established' : ''">
        <span [className]="item.logisticsDifferentValueAllowed ? 'value-exceeded' : ''">{{item.logistics | number: '1.2-2'}} </span>
        <span class="value-exceeded" *ngIf="item.logisticsDifferentValueAllowed">*</span>
      </td>
      <td mat-footer-cell *matFooterCellDef> {{totalLogistics | number: '1.2-2'}} </td>
    </ng-container>
    <ng-container matColumnDef="treatment">
      <th mat-header-cell *matHeaderCellDef>Treatment</th>
      <td mat-cell *matCellDef="let item"
          [matTooltip]="item.treatmentDifferentValueAllowed ? 'This value exceeded the marginal value established' : ''">
        <span [className]="item.treatmentDifferentValueAllowed ? 'value-exceeded' : ''">{{item.treatment | number: '1.2-2'}} </span>
        <span class="value-exceeded" *ngIf="item.treatmentDifferentValueAllowed">*</span>
      </td>
      <td mat-footer-cell *matFooterCellDef> {{totalTreatment | number: '1.2-2'}} </td>
    </ng-container>
    <ng-container matColumnDef="total">
      <th mat-header-cell *matHeaderCellDef>Total</th>
      <td mat-cell *matCellDef="let item">
        {{getOperationsRowTotalValue(item) | number: '1.2-2'}}
      </td>
      <td mat-footer-cell *matFooterCellDef> {{operationsTotalValue | number: '1.2-2'}} </td>
    </ng-container>
    <ng-container matColumnDef="remark">
      <th mat-header-cell *matHeaderCellDef>Remark</th>
      <td mat-cell *matCellDef="let item">{{item.operationsRemark}} </td>

      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsOperations"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsOperations;"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumnsOperations"></tr>
  </table>
</div>

<div class="table-container">
  <h3>Overhead</h3>
  <table *ngIf="kfRegistrationDetail" class="kf-registration-table-cost-overhead" mat-table
         [dataSource]="kfRegistrationDetail.categories">
    <ng-container matColumnDef="entry">
      <th mat-header-cell *matHeaderCellDef>Entry</th>
      <td mat-cell *matCellDef="let category; let i = index">
        {{categories[i].description}}
        <span>{{category.kind}}</span>
      </td>
      <td mat-footer-cell *matFooterCellDef> Total Overhead</td>
    </ng-container>
    <ng-container matColumnDef="clearing-house">
      <th mat-header-cell *matHeaderCellDef>Clearing House</th>
      <td mat-cell *matCellDef="let item"
          [matTooltip]="item.clearingHouseDifferentValueAllowed ? 'This value exceeded the marginal value established' : ''">
        <span
          [className]="item.clearingHouseDifferentValueAllowed ? 'value-exceeded' : ''">{{item.clearingHouse | number: '1.2-2'}} </span>
        <span class="value-exceeded" *ngIf="item.clearingHouseDifferentValueAllowed">*</span>
      </td>
      <td mat-footer-cell *matFooterCellDef> {{totalClearingHouse | number: '1.2-2'}} </td>
    </ng-container>
    <ng-container matColumnDef="communication">
      <th mat-header-cell *matHeaderCellDef>Communication</th>
      <td mat-cell *matCellDef="let item"
          [matTooltip]="item.communicationDifferentValueAllowed ? 'This value exceeded the marginal value established' : ''">
        <span
          [className]="item.communicationDifferentValueAllowed ? 'value-exceeded' : ''">{{item.communication | number: '1.2-2'}} </span>
        <span class="value-exceeded" *ngIf="item.communicationDifferentValueAllowed">*</span>
      </td>
      <td mat-footer-cell *matFooterCellDef> {{totalCommunication | number: '1.2-2'}} </td>
    </ng-container>
    <ng-container matColumnDef="rd">
      <th mat-header-cell *matHeaderCellDef>R&D</th>
      <td mat-cell *matCellDef="let item"
          [matTooltip]="item.rdDifferentValueAllowed ? 'This value exceeded the marginal value established' : ''">
        <span [className]="item.rdDifferentValueAllowed ? 'value-exceeded' : ''">{{item.rd | number: '1.2-2'}} </span>
        <span class="value-exceeded" *ngIf="item.rdDifferentValueAllowed">*</span>
      </td>
      <td mat-footer-cell *matFooterCellDef> {{totalRd | number: '1.2-2'}} </td>
    </ng-container>
    <ng-container matColumnDef="office">
      <th mat-header-cell *matHeaderCellDef>Office</th>
      <td mat-cell *matCellDef="let item"
          [matTooltip]="item.officeDifferentValueAllowed ? 'This value exceeded the marginal value established' : ''">
        <span [className]="item.officeDifferentValueAllowed ? 'value-exceeded' : ''">{{item.office | number: '1.2-2'}} </span>
        <span class="value-exceeded" *ngIf="item.officeDifferentValueAllowed">*</span>
      </td>
      <td mat-footer-cell *matFooterCellDef> {{totalOffice | number: '1.2-2'}} </td>
    </ng-container>
    <ng-container matColumnDef="other">
      <th mat-header-cell *matHeaderCellDef>Other</th>
      <td mat-cell *matCellDef="let item"
          [matTooltip]="item.otherDifferentValueAllowed ? 'This value exceeded the marginal value established' : ''">
        <span [className]="item.otherDifferentValueAllowed ? 'value-exceeded' : ''">{{item.other | number: '1.2-2'}} </span>
        <span class="value-exceeded" *ngIf="item.otherDifferentValueAllowed">*</span>
      </td>
      <td mat-footer-cell *matFooterCellDef> {{totalOther | number: '1.2-2'}} </td>
    </ng-container>
    <ng-container matColumnDef="total">
      <th mat-header-cell *matHeaderCellDef>Total</th>
      <td mat-cell *matCellDef="let item">
        {{getOverheadRowTotalValue(item) | number: '1.2-2'}}
      </td>
      <td mat-footer-cell *matFooterCellDef> {{overheadTotalValue | number: '1.2-2'}} </td>
    </ng-container>
    <ng-container matColumnDef="remark">
      <th mat-header-cell *matHeaderCellDef>Remark</th>
      <td mat-cell *matCellDef="let item"> {{item.overheadRemark}} </td>

      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsOverhead"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsOverhead;"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumnsOverhead"></tr>
  </table>
</div>

<div class="table-container">
  <h3>Payments to collection points</h3>
  <table class="kf-registration-table-additional" mat-table [dataSource]="additionalDataSource">
    <ng-container matColumnDef="entry">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let additional; let i = index">
        {{additional.category}}
      </td>
    </ng-container>

    <ng-container matColumnDef="paymentRetail">
      <th mat-header-cell *matHeaderCellDef>Payment to retail (€/ton)</th>
      <td mat-cell *matCellDef="let category; let i = index">
        {{category.paymentRetail | number: '1.2-2'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="paymentPoint">
      <th mat-header-cell *matHeaderCellDef>Payment to Municipal point (€/ton)</th>
      <td mat-cell *matCellDef="let category; let i = index">
        {{category.paymentPoint | number: '1.2-2'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="paymentOther">
      <th mat-header-cell *matHeaderCellDef>Payment to other collectors (€/ton)</th>
      <td mat-cell *matCellDef="let category; let i = index">
        {{category.paymentOther | number: '1.2-2'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="remarks">
      <th mat-header-cell *matHeaderCellDef>Remarks</th>
      <td mat-cell *matCellDef="let category; let i = index">
        {{category.remarks}}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="additionalDisplayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: additionalDisplayedColumns;"></tr>
  </table>

</div>
